import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const bullets = ['Cómo saber si tu bebé realmente está listo para empezar', 'Señales de madurez y preparación más allá de la edad', 'BLW, purés y alimentación combinada explicados sin extremismos', 'Diferencia entre arcada y atragantamiento real', 'Cómo introducir alérgenos de forma ordenada y segura', 'Nutrientes clave como hierro, zinc y grasas saludables', 'Cómo cortar alimentos y qué evitar al principio', 'Qué hacer con estreñimiento, sensibilidad digestiva y dudas frecuentes', '5 recetas prácticas y densas en nutrientes', 'Mitos comunes desmontados con claridad', 'Recursos útiles para sentirte acompañado/a desde el día uno'];
export function WhatYouWillFind() {
  return <section id="que-incluye" className="py-24 bg-white relative overflow-hidden" data-id="element-329">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-330">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-331">
          <motion.h2 className="text-4xl font-serif text-charcoal mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-332">
            ¿Qué encontrarás en Primeros Bocados?
          </motion.h2>
          <motion.p className="text-lg text-warmGray" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-333">
            Todo lo que necesitas para empezar con más criterio, calma y
            claridad.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-334">
          {/* Left: Checklist */}
          <motion.div className="space-y-4" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-335">
            {bullets.map((bullet, i) => <motion.div key={i} className="flex items-start gap-4" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} data-id="element-336">
                <div className="mt-1 bg-sage/20 p-1 rounded-full shrink-0" data-id="element-337">
                  <Check className="w-4 h-4 text-sage" data-id="element-338" />
                </div>
                <p className="text-charcoal leading-relaxed" data-id="element-339">{bullet}</p>
              </motion.div>)}

            <motion.button className="mt-8 bg-mauve hover:bg-mauve/90 text-white px-8 py-4 rounded-lg font-medium transition-colors shadow-sm inline-block" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.6
          }} onClick={() => document.getElementById('bonos')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-340">
              Quiero empezar con confianza
            </motion.button>
          </motion.div>

          {/* Right: Interior Mockups */}
          <div className="relative h-[600px] w-full hidden lg:block" data-id="element-341">
            <motion.div className="absolute right-0 top-10 w-3/4 h-[450px] bg-sand rounded-xl shadow-xl overflow-hidden border border-white/50" initial={{
            opacity: 0,
            rotate: 2,
            x: 50
          }} whileInView={{
            opacity: 1,
            rotate: 6,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-342">
              <img src="https://cdn.magicpatterns.com/uploads/v1zbt41owNvSyyxhYMFyXm/Gemini_Generated_Image_cshk0ucshk0ucshk1.png" alt="Alimentos y papillas para bebé" className="w-full h-full object-cover opacity-80" data-id="element-343" />
              <div className="absolute inset-0 bg-gradient-to-t from-white/80 via-transparent to-transparent" data-id="element-344" />
              <div className="absolute bottom-6 left-6 right-6" data-id="element-345">
                <div className="h-4 w-1/3 bg-charcoal/20 rounded mb-2" data-id="element-346" />
                <div className="h-2 w-full bg-charcoal/10 rounded mb-1" data-id="element-347" />
                <div className="h-2 w-4/5 bg-charcoal/10 rounded" data-id="element-348" />
              </div>
            </motion.div>

            <motion.div className="absolute left-0 bottom-10 w-3/4 h-[450px] bg-cream rounded-xl shadow-2xl overflow-hidden border border-white" initial={{
            opacity: 0,
            rotate: -2,
            x: -50
          }} whileInView={{
            opacity: 1,
            rotate: -4,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-349">
              <img src="https://cdn.magicpatterns.com/uploads/5C9RPEqgzsyKZetji6PuHz/Gemini_Generated_Image_td1t8ltd1t8ltd1t.png" alt="Niño con alimentos nutritivos" className="w-full h-48 object-cover" data-id="element-350" />
              <div className="p-8" data-id="element-351">
                <h4 className="font-serif text-2xl text-charcoal mb-4" data-id="element-352">
                  Nutrientes Clave
                </h4>
                <div className="space-y-3" data-id="element-353">
                  <div className="h-2 w-full bg-warmGray/20 rounded" data-id="element-354" />
                  <div className="h-2 w-full bg-warmGray/20 rounded" data-id="element-355" />
                  <div className="h-2 w-5/6 bg-warmGray/20 rounded" data-id="element-356" />
                  <div className="h-2 w-full bg-warmGray/20 rounded mt-6" data-id="element-357" />
                  <div className="h-2 w-4/5 bg-warmGray/20 rounded" data-id="element-358" />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}